import { defineMessages } from 'react-intl';
export var CANCEL_POLICY_HREF = 'https://help.classpass.com/hc/articles/207942743-What-is-the-class-cancellation-policy-';
export var messages = defineMessages({
  earlyDefault: {
    id: 'reservation.cancellation-policy.early',
    defaultMessage: 'If you can‘t make class, please cancel your reservation at least 12 hours in advance to avoid a <a href="{href}" target="_blank" rel="noopener noreferrer">fee</a>.',
    values: {
      href: CANCEL_POLICY_HREF
    }
  },
  earlyFlywheel: {
    id: 'reservation.cancellation-policy.early.flywheel',
    defaultMessage: 'If you can‘t make class, please cancel Flywheel/FlyBarre reservations by 5pm the day before class to avoid a <a href="{href}" target="_blank" rel="noopener noreferrer">fee</a>.',
    values: {
      href: CANCEL_POLICY_HREF
    }
  },
  earlyNonRefundable: {
    id: 'reservation.cancellation-policy.early.non-refundable',
    defaultMessage: ' Credit purchases are non-refundable and must be used by {date}.'
  },
  lateDefault: {
    id: 'reservation.cancellation-policy.late',
    defaultMessage: 'I understand that this class starts within 12 hours, so canceling my reservation later will result in a <a href="{href}" target="_blank" rel="noopener noreferrer">fee</a>.',
    values: {
      href: CANCEL_POLICY_HREF
    }
  },
  lateFlywheel: {
    id: 'reservation.cancellation-policy.late.flywheel',
    defaultMessage: 'I understand that Flywheel/FlyBarre reservations must be canceled by 5pm the night before class, so canceling my reservation later will result in a <a href="{href}" target="_blank" rel="noopener noreferrer">fee</a>.',
    values: {
      href: CANCEL_POLICY_HREF
    }
  },
  lateNonRefundable: {
    id: 'reservation.cancellation-policy.late.non-refundable',
    defaultMessage: ' I also understand that credit purchases are non-refundable and must be used by {date}.'
  }
});